import { JSONContent } from '@tiptap/react'
import { useCallback, useEffect, useRef } from 'react'
import { extractMarkdown } from '../../../lib/extract.js'

export const useExtractMarkdown = (value?: JSONContent | null) => {
  const markdownRef = useRef<string>('')

  const updateMarkdown = useCallback(() => {
    let latestJson = JSON.parse(JSON.stringify(value))
    // Remove nodes without content from the JSON structure
    if (value) {
      latestJson = cleanJson(value)
    }

    const extracted = extractMarkdown(latestJson)
    if (extracted && typeof extracted === 'string') {
      markdownRef.current = extracted
    }
  }, [value])

  useEffect(() => {
    if (value && value?.content?.length > 0) {
      updateMarkdown()
    } else {
      markdownRef.current = ''
    }
  }, [value])

  return {
    markdown: markdownRef.current,
  }
}

const cleanJson = (node: any): any => {
  if (!node) return null

  // If node has no  type, remove it
  if (!node?.type && !node?.attrs) {
    return null
  }

  if (
    [
      'tiktok',
      'twitter',
      'instagram',
      'facebook',
      'linkedin',
      'youtube',
      'insideLinks',
      'iframe',
      'videoBlock',
      'imageBlock',
      'linkPreview',
    ].includes(node?.type)
  ) {
    return null
  }

  // If node has content, recursively clean its children
  if (Array.isArray(node.content)) {
    const cleanContent = node.content.map(cleanJson).filter(Boolean)

    // If no valid children remain, return null
    if (cleanContent.length === 0) {
      return null
    }

    return {
      ...node,
      content: cleanContent,
    }
  }

  return node
}
